import DefaultUserDonationPage, {
  getServerSideProps,
} from "src/pages/User/UserDonationPage";

export default DefaultUserDonationPage;
export { getServerSideProps };
